import _classCallCheck from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Pass } from "./Pass.js";
/**
 * A shader pass.
 *
 * Renders any shader material as a fullscreen effect.
 *
 * This pass should not be used to create multiple chained effects. For a more
 * efficient solution, please refer to the {@link EffectPass}.
 */

export var ShaderPass =
/*#__PURE__*/
function (_Pass) {
  _inherits(ShaderPass, _Pass);

  /**
   * Constructs a new shader pass.
   *
   * @param {ShaderMaterial} material - A shader material.
   * @param {String} [input="inputBuffer"] - The name of the input buffer uniform.
   */
  function ShaderPass(material) {
    var _this;

    var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "inputBuffer";

    _classCallCheck(this, ShaderPass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShaderPass).call(this, "ShaderPass"));

    _this.setFullscreenMaterial(material);
    /**
     * The input buffer uniform.
     *
     * @type {String}
     * @private
     */


    _this.uniform = null;

    _this.setInput(input);

    return _this;
  }
  /**
   * Sets the name of the input buffer uniform.
   *
   * Most fullscreen materials modify texels from an input texture. This pass
   * automatically assigns the main input buffer to the uniform identified by
   * the given name.
   *
   * @param {String} input - The name of the input buffer uniform.
   */


  _createClass(ShaderPass, [{
    key: "setInput",
    value: function setInput(input) {
      var material = this.getFullscreenMaterial();
      this.uniform = null;

      if (material !== null) {
        var uniforms = material.uniforms;

        if (uniforms[input] !== undefined) {
          this.uniform = uniforms[input];
        }
      }
    }
    /**
     * Renders the effect.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
     * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
     * @param {Number} [delta] - The time between the last frame and the current one in seconds.
     * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
     */

  }, {
    key: "render",
    value: function render(renderer, inputBuffer, outputBuffer, delta, stencilTest) {
      if (this.uniform !== null) {
        this.uniform.value = inputBuffer.texture;
      }

      renderer.render(this.scene, this.camera, this.renderToScreen ? null : outputBuffer);
    }
  }]);

  return ShaderPass;
}(Pass);